// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__e36TI","star":"FormLabel_star__PMaMQ"};